import * as React from 'react';
import type { OnlineStudyTextsViewModel } from '../OnlineStudyTextsViewModel.csharp';
import type { OnlineApplicationChoice } from '~/Features/OnlineApplication/Model';
import type { TimeType } from '~/Pages/OnlineStudyPage/Semester/ParentStudyViewModel';
import type { TabKey } from '~/Partials/TabList/Tab';

export const OnlineStudyPlanContext = React.createContext<OnlineStudyPlanContextProps>(
    {} as OnlineStudyPlanContextProps
);

export interface OnlineStudyPlanContextProps extends ITabs, IBasket {
    getText: (textId: keyof OnlineStudyTextsViewModel) => string;
    getHoursPerWeekFromTimeType: (timeType: TimeType) => number;
}

interface ITabs {
    currentTab: TabKey;
    setCurrentTab: (tabKey: TabKey) => void;
}

interface IBasket extends IOnlineApplicationChoicesProvider, IOnlineApplicationChoicesClient {
    pointsInBasketExceededWarningThreshold: number;
    onlineApplicationFormUrl: string;

    setChoicesFromBasket: (setter: (prevState: OnlineApplicationChoice[]) => OnlineApplicationChoice[]) => void;
}

interface IOnlineApplicationChoicesProvider {
    setAddChoicesToBasketHandler: (
        addChoicesToBasket: (choices: OnlineApplicationChoice | OnlineApplicationChoice[]) => void
    ) => void;
    setRemoveChoicesFromBasketHandler: (
        removeChoicesFromBasket: (choices: OnlineApplicationChoice | OnlineApplicationChoice[]) => void
    ) => void;
}

interface IOnlineApplicationChoicesClient extends IOnlineApplicationChoicesGetters, IOnlineApplicationChoicesHandlers {}

interface IOnlineApplicationChoicesGetters {
    choicesFromBasket: OnlineApplicationChoice[];
}

export interface IOnlineApplicationChoicesHandlers {
    addChoicesToBasketHandler: (choices: OnlineApplicationChoice | OnlineApplicationChoice[]) => void;
    removeChoicesFromBasketHandler: (choices: OnlineApplicationChoice | OnlineApplicationChoice[]) => void;
}
